import {
  GENERATE_PENDING_ACTION_REPORT_PDF_REQUEST,
  GENERATE_PENDING_ACTION_REPORT_PDF_SUCCESS,
  GENERATE_PENDING_ACTION_REPORT_PDF_FAILURE
} from "actions/PendingActionReport/pendingActionReportAction";

const initialState = {
  pendingActionListReport: [],
  pendingActionReportData: {}
};

export default function pendingActionReportReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case GENERATE_PENDING_ACTION_REPORT_PDF_REQUEST:
      return {
        ...state
      };
    case GENERATE_PENDING_ACTION_REPORT_PDF_SUCCESS:
      return {
        ...state,
        pendingActionListReport: action.payload
      };
    case GENERATE_PENDING_ACTION_REPORT_PDF_FAILURE:
      return {
        ...state,
        error: action.payload
      };
    case 'PENDINGACTIONREPORTDATA':
      if (!action.payload) {
        return initialState;
      } else {
        return {
          ...state,
          pendingActionReportData: action.payload
        };
      }
    default:
      return state;
  }
}